import { z } from 'zod'
import { type Cnae } from '../../models/Cnae'

export const CnaeDTO = z.object({
  id: z.number(),
  code: z.union([z.number(), z.string()]),
  name: z.string()
})

export type CnaeDTO = z.infer<typeof CnaeDTO>

export function mapCnaeToDTO (model: Cnae): CnaeDTO {
  return {
    id: model.id!,
    code: model.code,
    name: model.name
  }
}

function parseCnaeCode (code: number | string): number {
  if (typeof code === 'number') {
    return code
  }

  const parsed = Number.parseInt(code, 10)
  return Number.isNaN(parsed) ? 0 : parsed
}

export function mapDTOToCnae (dto: CnaeDTO): Cnae {
  const codeForDisplay = String(dto.code)

  return {
    id: dto.id,
    code: parseCnaeCode(dto.code),
    name: dto.name ?? '',
    description: `${codeForDisplay} - ${dto.name}`
  }
}
